module.exports = __webpack_public_path__ + "img/audioPasue.e0d54a38.png";